import * as React from "react";
import {Modal} from "antd";
import locales from "../locales";
import SummaryTodoEditor from "./SummaryTodoEditor";
import {ClientRentalSummary} from "../api/dtos/summaries";

interface Props {
  summary: ClientRentalSummary | undefined;
  onSubmit: () => void;
  onCancel: () => void;
  selectedYear: number;
  selectedMonth: number;
}

class ClientRentalSummaryRemindersModal extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {summary, onSubmit, onCancel, selectedYear, selectedMonth} = this.props;
    return (
      <Modal
        title={locales.reminders}
        visible={summary !== undefined}
        footer={null}
        onCancel={onCancel}
        destroyOnClose={true}
      >
        {summary && (
          <SummaryTodoEditor
            summary={summary}
            selectedYear={selectedYear}
            selectedMonth={selectedMonth}
            onCancel={onCancel}
            onSubmit={onSubmit}
          />
        )}
      </Modal>
    );
  }
}

export default ClientRentalSummaryRemindersModal;


// WEBPACK FOOTER //
// ./src/summary/ClientRentalSummaryRemindersModal.tsx